module.exports = __webpack_public_path__ + "img/blade2.a822bd02.png";